import React from 'react';

import TextField from '../Molecules/TextField';
import NumberField from '../Molecules/NumberField';
import SelectField from '../Molecules/SelectField';
import SingleNextButton from '../Atoms/SingleNextButton';
import Form from '../StepComponents/Form';
import StepShell from '../StepComponents/StepShell';
import { getApp } from '../../index';
import { emailRegex, ssnRegex, dateRegex } from '../../Utils/ValidationPatterns';
import { relationTypes } from '../../Utils/SelectOptions';

class StepCoApplicantIdentity extends React.Component {
    render() {
        let relation;
        var coAppType = getApp('coApplicantType');
        if(coAppType === 'Joint and Non-Spousal' || coAppType === 'Co-signer and Non-Spousal'){
            relation = (
                <SelectField options={relationTypes} required={true} name="caRelation" placeholder="Select One" labelType="bold" label="What is your relationship to your co-applicant?"
                            />
            );
        }else{
            relation = "";
        }
        return (
            <StepShell stepID="StepCoApplicantIdentity"
                friendlyText="Sounds good. Tell us more about your co-applicant."
                requestText=""
                progress="62.5%"
                backLink="/loan-application/co-applicant"
                progressLabel="Co-Applicant Info"
            >
                <Form nextLink="/loan-application/co-applicant-contact">
                    {relation}
                    <TextField name="ca_fname" label="Co-Applicant's First Name" required={true}/>
                    <TextField name="ca_mname" label="Co-Applicant's Middle Name" />
                    <TextField name="ca_lname" label="Co-Applicant's Last Name" required={true}/>
                    <TextField name="ca_email" label="Co-Applicant's Email Address" required={true} type="email" pattern={emailRegex} title="example@example.com" />
                    <NumberField name="ca_dob" label="Co-Applicant's Date of Birth (e.g. 09/09/1999)" format="##/##/####" pattern={dateRegex} required={true}/>
                    <div className="hug">
                        <span className="cadob-message error-message">Your co-applicant needs to be 18 or older in order to submit this application.</span>
                    </div>
                    <NumberField name="ca_ssn" label="Co-Applicant's Social Security Number" encName="coapp_enc" encrypt={true} format="###-##-####" required={true} pattern={ssnRegex} />
                    <SingleNextButton nextBtnTxt="next"/>
                </Form>

            </StepShell>
        )
    }
}

export default StepCoApplicantIdentity;